export const sectionConfig = {
  desktops: {
    statusBar: 'StatusBar'
  },
  desktopsnew: {
    statusBar: 'StatusBar'
  },
  deployment: {
    statusBar: 'StatusBar'
  },
  deployment_videowall: {
    statusBar: 'StatusBar'
  },
  deployments: {
    statusBar: 'StatusBar'
  },
  booking: {
    statusBar: 'BookingStatusBar'
  },
  default: {
    statusBar: 'StatusBar'
  }
}
